import { useContext } from 'react';
import { AppContext } from './context/AppContext';
import NavBar from './NavBar';

function HeaderTemplate({title}:{title:string}) {
    const { navBarStatus, disMessage, navBarHandler } = useContext(AppContext);
    const [displayMessage]: string[] = disMessage;
    const [isNavbarOpen] = navBarStatus;
    const navBarClickHandler: (e: any) => void = navBarHandler

    return (
        <>
             {isNavbarOpen && 
            <span className='page-template-navbar-open'>
                <NavBar/>
            </span>
          }
          <div className={(displayMessage !== "none" || isNavbarOpen === true)?'page-template-header blur': 'page-template-header '}>
            <div className={(displayMessage !== "none" || isNavbarOpen === true)?'page-template-header-logo-navbar blur': 'page-template-header-logo-navbar'}>
              {!isNavbarOpen &&
                <span className='page-template-navbar-close' onClick={navBarClickHandler}>
                  <i className="fas fa-bars close-nav-bar-icon"></i>
                </span>
              }
              <span className='page-template-header-logo'>
                <img className="page-template-hoopo-img-logo" src="/hoopo_logo.jpg " alt='hoopo logo'/> 
              </span>
            </div>
            <div className={(displayMessage !== "none" || isNavbarOpen === true)?'page-template-h2 blur': 'page-template-h2'}>
                 {title}
            </div>
          </div>
        </>
    );
}

export default HeaderTemplate;